import React from 'react';
import { Step, Stepper as ReactStepper } from 'react-form-stepper';

const Stepper = ({ steps, getActiveStep, t }) => {
  return (
    <ReactStepper activeStep={getActiveStep()}>
      {steps.map((step) => {
        const id = step.id.replaceAll(' ', '');
        return <Step {...step} key={id} name={`${id}`} label={`${t(`label${id}`)}`} id={id} />;
      })}
    </ReactStepper>
  );
};

export default Stepper;
